// SearchType.jsx
'use strict';
import React from 'react';
import { useLoaderData } from 'react-router';

import UniversalContainer from '../component/UniversalContainer.jsx';
import MetaTagsHelmet from '../component/MetaTagsHelmet.jsx';
import prepareSearchPageMeta from '../resource/prepareSearchPageMeta.js';
import { searchType } from '../resource/searchConstants.js';
import { createInitialStoreWithRequest } from '../createInitialStore.js';
import { EMPTY_ARRAY } from '../resource/defaults.js';

/**
 * Loader for search type pages
 * Generates SEO meta tags and JSON-LD for SearchResultsPage
 */
export const loader = async ({ request, params }) => {
  const { type = searchType.ALL } = params;
  const url = new URL(request.url);
  const query = url.searchParams.get('q') || '';
  const hostname = url.hostname || 'swag.live';

  // Get Redux store
  const { store } = await createInitialStoreWithRequest({
    params,
    request,
  });
  const state = store.getState();

  // Build canonical URL
  const canonical = `https://${hostname}/search/${type}${query ? `?q=${encodeURIComponent(query)}` : ''}`;

  // Prepare meta tags with JSON-LD
  const meta = await prepareSearchPageMeta({
    state,
    query,
    type,
    hostname,
    includeJsonLd: true,
    canonical,
  });

  return {
    meta,
    params,
    staticContext: {
      requestHeaders: {
        hostname,
      },
    },
  };
};

const SearchTypeRoute = () => {
  const { meta = EMPTY_ARRAY } = useLoaderData();

  return (
    <>
      <MetaTagsHelmet metaTags={meta} />
      <UniversalContainer filename="Search" />
    </>
  );
};

export default SearchTypeRoute;
